<template>
  <div
    :id="gpAutotestName"
    :data-testid="gpAutotestName || undefined"
    :class="[
      type === 'tab' ? $style.tabs : $style.button,
      type === 'tab' && small ? $style.small : '',
      type === 'button' && tabs.length === 2 ? $style.button_equal : ''
    ]"
    :style="{ ...styles, '--tabs-active-color': color }"
  >
    <template
      v-for="(tab, index) in tabs"
      :key="index"
    >
      <div
        :class="[
          type === 'tab' ? $style.tabs_item : $style.button_item,
          (!disable || blocked) && tab[activeBy] === activeItem[activeBy] ? $style.active : '',
          gpAutotestName ? gpAutotestName + `_${tab.type}` : '',
          tab.marker ? $style.marker : '',
          disable ? $style.disable_tabs : '',
          blocked ? $style.blocked_tabs : '',
          type === 'button' && tabs.length === 2 ? $style.button_item__equal : ''
        ]"
        :data-testid="tabTestId(tab)"
        :style="{
          width: getWidth(tab),
          maxWidth: getMaxWidth(tab)
        }"
        @click="selectTab(tab)"
      >
        <sprite
          v-if="tab.icon"
          :class="$style.tabs_item__icon"
          :name="tab.icon.name"
          :size="tab.icon.size || 20"
          :type="tab.icon.type || 'regular'"
        />
        <span
          :class="[type === 'tab' ? $style.tabs_item__title : $style.button_item__title]"
          :style="{
            marginLeft: tab.icon ? '4px' : '',
            fontSize: getFontSize(tab),
            width: fixedWidth ? fixedWidth : ''
          }"
        >
          {{ tab.title }}
          <span v-if="amountTextByType[tab.type]">&nbsp;{{ amountTextByType[tab.type] }}</span>
        </span>
      </div>

      <div
        v-if="type === 'button' && tabs.length > 2 && index < tabs.length - 1"
        :class="$style.button_item__separator"
      />
    </template>
  </div>
</template>

<script>
import sprite from '$$uiKitComp/VueIcon/svgSprite.vue';

export default {
  components: { sprite },
  props: {
    gpAutotestName: {
      type: String,
      required: false,
      default: '',
    },
    tabs: {
      type: Array,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: true,
    },
    activeBy: {
      type: String,
      required: false,
      default: 'id',
    },
    type: {
      type: String,
      required: false,
      default: 'tab',
    },
    active: {
      type: Object,
      default: null,
    },
    amounts: {
      type: Object,
      required: false,
      default: {},
    },
    color: {
      type: String,
      required: false,
      default: '#1565C0',
    },
    styles: { type: Object, required: false, default: {} },
    fixedWidth: {
      type: String,
      required: false,
      default: '',
    },
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
    blocked: {
      type: Boolean,
      required: false,
      default: false,
    },
    blockedInnerSelection: { type: Boolean, required: false, default: false },
  },
  emits: [
    'onToggle',
  ],
  data() {
    return {
      activeItem: this.active,
    };
  },

  computed: {
    amountTextByType() {
      const normalizeAmount = value => {
        if (value === undefined || value === null) return '';
        if (value === '' || Number.isNaN(Number(value))) return '';

        const numeric = Number(value);

        if (numeric <= 0) return '';
        if (numeric >= 100) return '99+';

        return numeric;
      };

      const amounts = this.amounts || {};

      return Object.keys(amounts).reduce((acc, key) => {
        acc[key] = normalizeAmount(amounts?.[key]);

        return acc;
      }, {});
    },
  },

  watch: {
    active(val) {
      if (val) {
        this.activeItem = val;
      }
    },
  },

  methods: {
    getWidth(tab) {
      if (tab.width) {
        return `${tab.width}`;
      }

      if (this.type === 'button') {
        return '';
      }

      return '';
    },

    getMaxWidth(tab) {
      if (tab.width) {
        return `${tab.width}px`;
      }

      return '';
    },

    getFontSize(tab) {
      if (tab.fontSize) {
        return `${tab.fontSize}px`;
      }

      return '14px';
    },

    tabTestId(tab) {
      if (tab.testId) {
        return tab.testId;
      }

      if (tab.dataTestid) {
        return tab.dataTestid;
      }

      if (this.gpAutotestName && tab.type) {
        return `${this.gpAutotestName}_${tab.type}`;
      }

      return undefined;
    },

    selectTab(tab) {
      if (this.disable || this.blocked) return;
      this.activeItem = tab;
      this.$emit('onToggle', tab);

      if (!this.blockedInnerSelection) {
        this.activeItem = tab;
      }
    },
  },
};
</script>

<style module lang="less" src='./less/tabs.less'></style>
